import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { swalError, swalLoading, swalSuccess } from "@/utils/lib/swal";
import { SubmitButton } from "@/components/ui/button";
import {
  BuildingPayloadSchema,
  buildingPayloadSchema,
  useBuilding,
  useBuildingEdit,
} from "@/api/building";
import { Loading } from "@/components/ui/loading";
import { BuildingFormFields } from "./BuildingFormFields";
import { FormContainer } from "@/components/form/form-container";
import { Anchor } from "@/components/ui/anchor";
import { FormInfo } from "@/components/ui/form-info";

export function BuildingEditForm({ id }: { id: string }) {
  const { data: building, isPending: isLoadingData } = useBuilding({
    id,
  });
  const form = useForm<BuildingPayloadSchema>({
    resolver: zodResolver(buildingPayloadSchema),
    defaultValues: {
      categoryBizpass: building?.categoryBizpass,
      dwellingType: building?.dwellingType,
    },
    values: building,
  });
  const { mutate, isPending } = useBuildingEdit();
  const navigate = useNavigate();

  const handleSubmit = (values: BuildingPayloadSchema) => {
    swalLoading.fire();
    mutate(
      { id: id, data: values },
      {
        onSuccess: () => {
          swalSuccess
            .fire({
              text: "Category Bizzpass has been updated",
            })
            .then(() => navigate("/master-data/category-bizzpass"));
        },
        onError: (error) => {
          swalError.fire({
            text: error.message,
          });
        },
      },
    );
  };

  if (isLoadingData) {
    return <Loading />;
  }

  return (
    <FormContainer form={form} onSubmit={handleSubmit}>
      <FormInfo
        label="Terms"
        values={[
          "Fill in Dwelling Type U for home-biz, or H for home (according to the homepass manager standard)",
        ]}
      />
      <BuildingFormFields />
      <div className="ml-auto flex gap-x-2">
        <Anchor
          href="/master-data/category-bizzpass"
          mood="axiata-blue-outline"
        >
          Cancel
        </Anchor>
        <SubmitButton loading={isPending} />
      </div>
    </FormContainer>
  );
}
